import { FC } from "react";
import { Paragraph, Image, Grid, Card } from "capitalrx-components-2.0";

import styles from "./DownloadApp.module.scss";

import cellPhones from "@/static/images/android-phones-composite-min.png";
import stevieAward from "@/static/images/award-logos/stevie.svg?url";
import accenture from "@/static/images/award-logos/accenture.svg?url";
import incBinB from "@/static/images/award-logos/incBinB.svg?url";
import nychbl from "@/static/images/award-logos/nychbl.svg?url";
import inc5000 from "@/static/images/award-logos/inc5000.svg?url";

const DesktopView: FC = () => {
  return (
    <div className={styles.sectionContainerDesktop} data-testid="download-container-desktop">
      <Grid container className={styles.cellphoneSection}>
        <Grid item colLg={6} colMd={9} className={styles.cellphoneSectionTextContainer}>
          <div className={styles.cellphoneSectionText} data-testid="download-container-desktop-text-1">
            Transparent, consistent drug pricing is important to us because it&apos;s important to you.
          </div>
        </Grid>
        <Grid item colLg={6} colMd={9} className={styles.cellphoneSectionImgContainer}>
          <Image src={cellPhones} testId="cell-phone-image" alt="Advantage App" ariaHidden="true" />
        </Grid>
      </Grid>

      <Card className={styles.ctaCard}>
        <Grid container justifyContent="center">
          <Grid item colLg={12} className={styles.qrcodeContainer}>
            <Paragraph className={styles.ctaText} testId="download-container-desktop-text-2">
              Capital Rx is an <span className={styles.emphasizedText}>award-winning healthcare disruptor</span> transforming the way that
              prescriptions are priced and administered.
            </Paragraph>
          </Grid>
          <Grid item colLg={12} className={styles.appContainerAwards}>
            <div className={styles.stevie}>
              <Image src={stevieAward} testId="stevie-award-image" alt="2022 Stevie Winner - Bronze" />
            </div>
            <div className={styles.accenture}>
              <Image src={accenture} testId="accenture-award-image" alt="2020 Accenture Innocation Challenge" />
            </div>
            <div className={styles.incBinB}>
              <Image src={incBinB} testId="inc-award-image" alt="Inc. Best in Business 2021" />
            </div>
            <div className={styles.nychbl}>
              <Image src={nychbl} testId="nychbl-award-image" alt="New York City Health Business Leaders 2020, 2021, 2022" />
            </div>
            <div className={styles.inc}>
              <Image src={inc5000} testId="inc-5000-award-image" alt="Inc. 5000 America's Fastest Growing Private Companies" />
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default DesktopView;
